import { CLEAR_ALL, LOGOUT } from '../../store/Types';

export const ALL_USU_ACTIVIDADES_EXTRACUR = 'ALL_USU_ACTIVIDADES_EXTRACUR';
export const LOADING_ALL_USU_ACTIVIDADES_EXTRACUR =
  'LOADING_ALL_USU_ACTIVIDADES_EXTRACUR';
export const ACTIVO_USU_ACTIVIDADES_EXTRACUR =
  'ACTIVO_USU_ACTIVIDADES_EXTRACUR';
export const PARAMS_USU_ACTIVIDADES_EXTRACUR =
  'PARAMS_USU_ACTIVIDADES_EXTRACUR';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const actividadesExtCurReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_USU_ACTIVIDADES_EXTRACUR:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_USU_ACTIVIDADES_EXTRACUR:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_USU_ACTIVIDADES_EXTRACUR:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_USU_ACTIVIDADES_EXTRACUR:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
